import { Component, inject, input } from '@angular/core';
import { WeatherForecastService } from '../weather-forecast.service';

@Component({
  selector: 'app-weather-forecast-icon',
  templateUrl: './weather-forecast-icon.component.html',
  styleUrls: ['./weather-forecast-icon.component.scss'],
  providers: [WeatherForecastService],
  standalone: false,
})
export class WeatherForecastIconComponent {
  private readonly weatherForecastService = inject(WeatherForecastService);

  readonly symbol = input<string>(undefined);
  readonly width = input<number>(undefined);
  readonly height = input<number>(undefined);

  get weatherIcon() {
    return this.weatherForecastService.getIconSvg(this.symbol());
  }
}
